import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=92db5e28&scoped=true&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"
import style0 from "./custom-grid.css?vue&type=style&index=0&id=92db5e28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92db5e28",
  null
  
)

export default component.exports